import fetch from '@/config/fetch'
import {deleteImgPath, uploadImgPath} from "../config/env";

/**
 * 登陆
 */
export function login(data) {
    return fetch({
        url: '/admin/login',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        params: {"username": data.userName, "password": data.password,},
    });
};

/**
 * 退出
 */
export function signout(data) {
    return fetch({
        url: '/admin/logout',
        method: 'get',
        params: data
    });
}

/**
 * 获取全部登陆账号信息
 */
export function getMenu(data) {
    return fetch({
        url: '/admin/getMenu',
        method: 'get',
        params: data
    });
}

export function getAdminList(data) {
    return fetch({
        url: '/admin/getAdminInfo',
        method: 'get',
        params: data
    });
}

export function getAdminAll(data) {
    return fetch({
        url: '/admin/getAdminAll',
        method: 'get',
        params: data
    });
}

/**
 * 获取员工信息
 */
export function getEmployee(data) {
    return fetch({
        url: '/group/getGroupAll',
        method: 'get',
        params: data
    });
}

/**
 * 获取全部菜单的信息，带分层
 */
export function getMenuAllPage(data) {
    return fetch({
        url: '/menu/getMenu',
        method: 'get',
        params: data
    });
}

/**
 * 获取全部菜单的信息，不带分层
 */
export function getMenuAll(data) {
    return fetch({
        url: '/menu/getMenuAll',
        method: 'get',
        params: data
    });
}

/**
 * 获取所有父菜单
 */
export function getParentMenu(data) {
    return fetch({
        url: '/menu/getParentMenu',
        method: 'get',
        params: data
    });
}

/**
 * 获取用户组全部菜单的信息
 */
export function getMenuByGroupId(data) {
    return fetch({
        url: '/menu/getMenuByGroupId',
        method: 'get',
        params: data
    });
}

/**
 * 更新菜单
 * */
export function modifyMenu(data) {
    return fetch({
        url: '/menu/modifyMenu',
        method: 'POST',
        data
    });
}

/**
 * 更新用户组菜单权限
 */
export function modifyGroup(data) {
    return fetch({
        url: '/group/modifyGroup',
        method: 'POST',
        data
    });
}

/**
 * 删除用户组和菜单权限
 */
export function deleteGroup(data) {
    return fetch({
        url: '/group/deleteGroup',
        method: 'get',
        params: data
    });
}

/**
 * 删除菜单
 * */
export function deleteMenu(data) {
    return fetch({
        url: 'menu/deleteMenu',
        method: 'get',
        params: data
    });
}

/**
 * 获取全部组信息，不带分层的,用于员工设置编辑页面
 * */
export function getGroupInfo(data) {
    return fetch({
        url: 'group/getGroupAll',
        method: 'get',
        params: data
    });
}

/**
 * 获取用户的全部权限
 * */
export function getUserGroupByUserId(data) {
    return fetch({
        url: '/adminGroup/getAdminGroupByAdminId',
        method: 'get',
        params: data
    });
}


/**
 * 获取当前登录用户的权限
 * */
export function getUserGroupId() {
    return fetch({
        url: '/adminGroup/getUserGroupId',
        method: 'get'
    });
}

/**
 * 新增或更新用户
 * */
export function addOrUpdateUser(data) {
    return fetch({
        url: '/admin/addOrUpdateAdmin',
        method: 'POST',
        data
    });
}

//用户删除
export function deleteUser(data) {
    return fetch({
        url: '/admin/delete',
        method: 'get',
        params: data
    });
}


/**
 * 获取账户信息
 * */
export function getUserPage(data) {
    return fetch({
        url: '/user/getUserPage',
        method: 'get',
        params: data
    });
}

/**
 * 获取单个账户信息
 * */
export function getUserById(data) {
    return fetch({
        url: '/user/getUserInfoById',
        method: 'get',
        params: data
    });
}


/**
 * 直接获取用户信息
 * */
export function getUserList(data) {
    return fetch({
        url: '/user/getUserList',
        method: 'get',
        params: data
    });
}


/**
 * 更新用户
 * */
export function modifyUser(data) {
    return fetch({
        url: '/user/modifyUser',
        method: 'POST',
        data
    });
}


/**
 * 删除图片
 * */
export function deleteImage(data) {
    return fetch({
        baseURL: deleteImgPath,
        url: '/deleteImage',
        method: 'get',
        params: data
    });
}

/**
 * 获取微信参数
 * */
export function getSysConfig(data) {
    return fetch({
        url: 'sysConfig/getSysConfig',
        method: 'get',
        params: data
    });
}

/**
 * 更新微信参数
 * */
export function modifySysConfig(data) {
    return fetch({
        url: 'sysConfig/modifySysConfig',
        method: 'POST',
        data
    });
}

/**
 *  获取数据
 * */
export function getSysCode(data) {
    return fetch({
        url: '/sysCode/getCodePage',
        method: 'get',
        params: data
    });
}

export function modifyCodeDict(data) {
    return fetch({
        url: '/sysCode/modifyCodeDict',
        method: 'POST',
        data
    });
}

export function deleteCodeDict(data) {
    return fetch({
        url: '/sysCode/deleteCodeDict',
        method: 'POST',
        data
    });
}

export function getUserByCondictionExport(data) {
    return fetch({
        url: 'user/getUserByCondictionExport',
        method: 'get',
        params: data,
        responseType: 'blob'
    });
}

/**
 * 更新机构
 */
export function saveDepat(data) {
    return fetch({
        url: '/depat/saveDepat',
        method: 'POST',
        data
    });
}

/**
 * 删除机构
 */
export function deleteDepat(data) {
    return fetch({
        url: '/depat/deleteDepat',
        method: 'get',
        params: data
    });
}

/**
 * 获取机构树
 */
export function findDeptTree(data) {
    return fetch({
        url: '/depat/findDeptTree',
        method: 'get',
        params: data
    });
}


/**
 * 根据type获取权限树
 */
export function getMenuByType(data) {
    return fetch({
        url: '/menu/getMenuByType',
        method: 'get',
        params: data
    });
}


/**
 * 根据type获取权限树
 */
export function getDepatByadminId(data) {
    return fetch({
        url: '/adminDepat/getDepatByadminId',
        method: 'get',
        params: data
    });
}

/**
 * 获取一级机构
 */
export function findDepat(data) {
    return fetch({
        url: '/depat/findDepat',
        method: 'get',
        params: data
    });
}

/**
 * 获取code列表
 */
export function getCodeList(data) {
    return fetch({
        url: '/sysCode/getCodeList',
        method: 'get',
        params: data
    });
}

/**
 * 根据names获取code
 * */
export function getCodeByNames(data) {
    return fetch({
        url: '/sysCode/getCodeByNames',
        method: 'get',
        params: data
    });
}

/************************************************************************************************************************/

/**
 * 获取地图信息
 */
export function getMapInfo(data) {
    return fetch({
        url: '/peasant/getMapInfo',
        method: 'get',
        params: data
    });
}


/**
 *  获取视频流
 * */
export function getSysCameraList(data) {
    return fetch({
        url: '/sysCamera/getSysCameraList',
        method: 'get',
        params: data
    });
}

/**
 *  获取视频流
 * */
export function getSysCameraDetailById(data) {
    return fetch({
        url: '/sysCamera/getSysCameraDetailById',
        method: 'get',
        params: data
    });
}

/**
 *  开始摄像头推流
 * */
export function startPush(data) {
    return fetch({
        url: '/sysCamera/startPush',
        method: 'get',
        params: data
    });
}
/**
 *  保持激活摄像头推流
 * */
export function keepAlive(data) {
    return fetch({
        url: '/sysCamera/keepAlive',
        method: 'get',
        params: data
    });
}

/**
 * 结束摄像头推流
 * */
export function stopPush(data) {
    return fetch({
        url: '/sysCamera/stopPush',
        method: 'get',
        params: data
    });
}



/**
 *  获取地区树
 * */
export function getRegionTree(data) {
    return fetch({
        url: '/sysRegion/getRegionTree',
        method: 'get',
        params: data
    });
}

/**
 *  获取地区在地图的数据
 * */
export function getRegionMap(data) {
    return fetch({
        url: '/sysRegion/getRegionMap',
        method: 'get',
        params: data
    });
}

/**
 *  更新地区
 * */
/*
 export function modifyRegion(data) {
    return fetch({
        url: '/sysRegion/modifySysRegion',
        method: 'POST',
        data
    });
}
*/

/**
 *  获取地图上数据
 * */
export function getHomeMapInfo(data) {
    return fetch({
        url: '/map/getMapInfo',
        method: 'POST',
        data
    });
}

/**
 *  获取地图上点位数据
 * */
export function getHomeMapPoints(data) {
    return fetch({
        url: '/map/getMapPoints',
        method: 'POST',
        data
    });
}

/**
 * 根据Id删除地区，包括子节点
 * */
export function deleteSysRegionById(data) {
    return fetch({
        url: '/sysRegion/deleteSysRegionById',
        method: 'get',
        params: data
    });
}



/**
 * 获取农药店摄像头
 * */
export function getSysCameraPage(data) {
    return fetch({
        url: '/sysCamera/getSysCameraPage',
        method: 'get',
        params: data
    });
}

export function modifySysCamera(data) {
    return fetch({
        url: '/sysCamera/modifySysCamera',
        method: 'POST',
        data
    });
}


/**
 *  分页获取志愿者管理数据
 * */
export function getZhiyuanzhePage(data) {
    return fetch({
        url: '/zhiyuanzhe/getZhiyuanzhePage',
        method: 'get',
        params: data
    });
}


/**
 *  分页获取志愿者管理数据
 * */
export function getZhiyuanzheImports(data) {
    return fetch({
        url: '/zhiyuanzhe/getZhiyuanzheImports',
        method: 'get',
        params: data
    });
}


/**
 *  积分获取列表
 * */
export function getZhiyuanzheScoreList(data) {
    return fetch({
        url: '/zhiyuanzhe/getZhiyuanzheScoreList',
        method: 'get',
        params: data
    });
}

/**
 *  分页获取志愿者管理数据
 * */
export function getZhiyuanzhePositionPage(data) {
    return fetch({
        url: '/zhiyuanzhe/getZhiyuanzhePositionPage',
        method: 'get',
        params: data
    });
}

export function getDictionaryData(data) {
    return fetch({
        url: '/zhiyuanzhe/getDictionaryData',
        method: 'get',
        params: data
    });
}


/**
 *  分页获取志愿者管理数据 - 志愿者审核
 * */
export function getZhiyuanzheVerify(data) {
    return fetch({
        url: '/zhiyuanzhe/getZhiyuanzheVerify',
        method: 'get',
        params: data
    });
}


/**
 *  志愿者加入团队待审核
 * */
export function getZhiyuanzheTemeVerifyPage(data) {
    return fetch({
        url: '/zhiyuanzheTeam/getZhiyuanzheTemeVerifyPage',
        method: 'get',
        params: data
    });
}


/**
 *  列表获取志愿者管理数据
 * */
export function getZhiyuanzheList(data) {
    return fetch({
        url: '/zhiyuanzhe/getZhiyuanzheList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑志愿者管理
 * */
export function modifyZhiyuanzhe(data) {
    return fetch({
        url: '/zhiyuanzhe/modifyZhiyuanzhe',
        method: 'POST',
        data
    });
}

/**
 *  删除志愿者管理
 * */
export function deleteZhiyuanzheById(data) {
    return fetch({
        url: '/zhiyuanzhe/deleteZhiyuanzheById',
        method: 'get',
        params: data
    });
}


export function deleteTeamZyzById(data) {
    return fetch({
        url: '/teamZyz/deleteTeamZyzById',
        method: 'get',
        params: data
    });
}

export function deleteZhiyuanzhePositionById(data) {
    return fetch({
        url: '/zhiyuanzhe/deleteZhiyuanzhePositionById',
        method: 'get',
        params: data
    });
}

export function addZhiyuanzhePositionById(data) {
    return fetch({
        url: '/zhiyuanzhe/addZhiyuanzhePositionById',
        method: 'get',
        params: data
    });
}

/**
 *  根据Id获取志愿者管理详细信息
 * */
export function getZhiyuanzheDetailById(data) {
    return fetch({
        url: '/zhiyuanzhe/getZhiyuanzheDetailById',
        method: 'get',
        params: data
    });
}

/**
 *  志愿者审核通过
 * */
export function passZhiyuanzheById(data) {
    return fetch({
        url: '/zhiyuanzhe/passZhiyuanzheById',
        method: 'get',
        params: data
    });
}

/**
 *  志愿者审核通过
 * */
export function passZhiyuanzheTeamById(data) {
    return fetch({
        url: '/zhiyuanzheTeam/passZhiyuanzheTeamById',
        method: 'get',
        params: data
    });
}

/**
 *  志愿者审核通过 - 批量审核通过
 * */
export function passAllZhiyuanzheById(data) {
    return fetch({
        url: '/zhiyuanzhe/passAllZhiyuanzheById',
        method: 'get',
        params: data
    });
}

/**
 * 扣积分
 */
export function zyzScoreZhiyuanzheById(data){
    return fetch({
        url: '/zhiyuanzhe/zyzScoreZhiyuanzheById',
        method: 'get',
        params: data
    });
}

/**
 *  分页获取志愿者导入数据
 * */
export function getZhiyuanzheImportPage(data) {
    return fetch({
        url: '/zhiyuanzheImport/getZhiyuanzheImportPage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取志愿者导入数据
 * */
export function getZhiyuanzheImportList(data) {
    return fetch({
        url: '/zhiyuanzheImport/getZhiyuanzheImportList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑志愿者导入
 * */
export function modifyZhiyuanzheImport(data) {
    return fetch({
        url: '/zhiyuanzheImport/modifyZhiyuanzheImport',
        method: 'POST',
        data
    });
}

/**
 *  下载模板
 * */
export function downloadZhiyuanzheImport(data) {
    return fetch({
        url: '/zhiyuanzheImport/downloadZhiyuanzheImport',
        method: 'get',
        params: ''
    });
}

/**
 *  批量删除志愿者导入
 * */
export function deleteZhiyuanzheImportByIds(data) {
    return fetch({
        url: '/zhiyuanzheImport/deleteZhiyuanzheImportByIds',
        method: 'get',
        params: data
    });
}

/**
 *  删除全部志愿者导入
 * */
export function deleteZhiyuanzheImportAll(data) {
    return fetch({
        url: '/zhiyuanzheImport/deleteAll',
        method: 'get',
        params: ''
    });
}

/**
 *  删除志愿者导入
 * */
export function deleteZhiyuanzheImportById(data) {

    return fetch({
        url: '/zhiyuanzheImport/deleteZhiyuanzheImportById',
        method: 'get',
        params: data
    });
}

/**
 *  根据Id获取志愿者导入详细信息
 * */
export function getZhiyuanzheImportDetailById(data) {
    return fetch({
        url: '/zhiyuanzheImport/getZhiyuanzheImportDetailById',
        method: 'get',
        params: data
    });
}

/**
 *  分页获取志愿者团队活动数据
 * */
export function getTeamActivityPage(data) {
    return fetch({
        url: '/teamActivity/getTeamActivityPage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取志愿者团队活动数据
 * */
export function getTeamActivityList(data) {
    return fetch({
        url: '/teamActivity/getTeamActivityList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑志愿者团队活动
 * */
export function modifyTeamActivity(data) {
    return fetch({
        url: '/teamActivity/modifyTeamActivity',
        method: 'POST',
        data
    });
}

/**
 *  删除志愿者团队活动
 * */
export function deleteTeamActivityById(data) {
    return fetch({
        url: '/teamActivity/deleteTeamActivityById',
        method: 'get',
        params: data
    });
}

/***
 * 改变精选活动状态
 */
 export function updateTeamActivityJXById(data) {
    return fetch({
        url: '/teamActivity/updateTeamActivityJXById',
        method: 'post',
        params: data
    });
}

/**
 *  根据Id获取志愿者团队活动详细信息
 * */
export function getTeamActivityDetailById(data) {
    return fetch({
        url: '/teamActivity/getTeamActivityDetailById',
        method: 'get',
        params: data
    });
}

/**
 *  分页获取团队活动报名数据
 * */
export function getTeamApplyPage(data) {
    return fetch({
        url: '/teamApply/getTeamApplyPage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取团队活动报名数据
 * */
export function getTeamApplyList(data) {
    return fetch({
        url: '/teamApply/getTeamApplyList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑团队活动报名
 * */
export function modifyTeamApply(data) {
    return fetch({
        url: '/teamApply/modifyTeamApply',
        method: 'POST',
        data
    });
}

/**
 * 获取志愿者数据列表
 */
export function getUserListOnTeamApply(){
    return fetch({
        url: '/teamApply/getUserList',
        method:'GET'
    });
}


/**
 *  删除团队活动报名
 * */
export function deleteTeamApplyById(data) {
    return fetch({
        url: '/teamApply/deleteTeamApplyById',
        method: 'get',
        params: data
    });
}

/**
 *  审核团队活动报名
 * */
export function passTeamApplyById(data) {
    return fetch({
        url: '/teamApply/passTeamApplyById',
        method: 'get',
        params: data
    });
}

/**
 *  根据Id获取团队活动报名详细信息
 * */
export function getTeamApplyDetailById(data) {
    return fetch({
        url: '/teamApply/getTeamApplyDetailById',
        method: 'get',
        params: data
    });
}

/**
 *  分页获取志愿者团队数据
 * */
export function getZhiyuanzheTeamPage(data) {
    return fetch({
        url: '/zhiyuanzheTeam/getZhiyuanzheTeamPage',
        method: 'get',
        params: data
    });
}

/**
 *  分页获取志愿者团队数据 - 数据统计
 * */
export function getTeamData(data) {
    return fetch({
        url: '/zhiyuanzheTeam/getTeamData',
        method: 'POST',
        params: data
    });
}


/**
 *  分页获取志愿者团队数据统计
 * */
export function getZhiyuanzheTeamCountPage(data) {
    return fetch({
        url: '/zhiyuanzheTeam/getZhiyuanzheTeamCountPage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取志愿者团队数据
 * */
export function getZhiyuanzheTeamList(data) {
    return fetch({
        url: '/zhiyuanzheTeam/getZhiyuanzheTeamList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑志愿者团队
 * */
export function modifyZhiyuanzheTeam(data) {

    return fetch({
        url: '/zhiyuanzheTeam/modifyZhiyuanzheTeam',
        method: 'POST',
        data
    });
}

/**
 *  删除志愿者团队
 * */
export function deleteZhiyuanzheTeamById(data) {
    return fetch({
        url: '/zhiyuanzheTeam/deleteZhiyuanzheTeamById',
        method: 'get',
        params: data
    });
}

/**
 *  志愿者团队审核
 * */
export function verifyZhiyuanzheTeamById(data) {
    return fetch({
        url: '/zhiyuanzheTeam/verifyZhiyuanzheTeam',
        method: 'GET',
        params: data
    });
}

/**
 * 志愿者团队数据导出
 */
export function verifyZhiyuanzheTeamDownload(data){
    return fetch({
        url: '/zhiyuanzheTeam/zhiyuanzheTeamDownload',
        method: 'GET',
        params: data,
        responseType: 'blob'
    });
}

/**
 *  根据Id获取志愿者团队详细信息
 * */
export function getZhiyuanzheTeamDetailById(data) {
    return fetch({
        url: '/zhiyuanzheTeam/getZhiyuanzheTeamDetailById',
        method: 'get',
        params: data
    });
}


/**
 *  首页获取统计数据，
 * */
export function getHomeDatePage(data) {
    return fetch({
        url: '/zhiyuanzheTeam/getHomeDatePage',
        method: 'get',
        params: data
    });
}


/**
 *  首页获取统计数据，
 * */
export function getHomeDataLinePage(data) {
    return fetch({
        url: '/zhiyuanzheTeam/getHomeDataLinePage',
        method: 'get',
        params: data
    });
}


/**
 *  首页获取统计数据 - 团队志愿者总人数
 * */
export function getHomeZheyuanzheTeam(data) {
    return fetch({
        url: '/zhiyuanzheTeam/getHomeZheyuanzheTeam',
        method: 'get',
        params: data
    });
}


/**
 *  首页获取统计数据 - 团队志愿者志愿总时长
 * */
export function getHomeZheyuanzheTeamTime(data) {
    return fetch({
        url: '/zhiyuanzheTeam/getHomeZheyuanzheTeamTime',
        method: 'get',
        params: data
    });
}


/**
 *  首页获取统计数据 - 团队活动报名总人数
 * */
export function getHomeZheyuanzheTeamActivity(data) {
    return fetch({
        url: '/zhiyuanzheTeam/getHomeZheyuanzheTeamActivity',
        method: 'get',
        params: data
    });
}

/**
 * 获取团队下拉列表的数据
 * */
export function getTeamKeyValueList(data) {
    return fetch({
        url: '/zhiyuanzheTeam/getTeamKeyValueList',
        method: 'get',
        params: data
    });
}

/**
 * 获取城市列表和活动类型
 */
export function getActivityTypeAndCity(data){
    return fetch(
        {
            url:'/teamActivity/getActivityTypeAndCity',
            method: 'get',
            params: data
        }
    );
}

/**
 * 获取活动类型
 */
export function getActivityTagList(data){
    return fetch(
        {
            url:'/teamActivity/getActivityTagList',
            method: 'get',
            params: data
        }
    );
}

/**
 *  分页获取图片广告管理数据
 * */
export function getSysImgPage(data) {
    return fetch({
        url: '/sysImg/getSysImgPage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取图片广告管理数据
 * */
export function getSysImgList(data) {
    return fetch({
        url: '/sysImg/getSysImgList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑图片广告管理
 * */
export function modifySysImg(data) {
    return fetch({
        url: '/sysImg/modifySysImg',
        method: 'POST',
        data
    });
}

/**
 *  删除图片广告管理
 * */
export function deleteSysImgById(data) {
    return fetch({
        url: '/sysImg/deleteSysImgById',
        method: 'get',
        params: data
    });
}

/**
 *  根据Id获取图片广告管理详细信息
 * */
export function getSysImgDetailById(data) {
    return fetch({
        url: '/sysImg/getSysImgDetailById',
        method: 'get',
        params: data
    });
}

/**
 * 获取图片type
 */
export function gettypeList(data){
    return fetch({
        url: '/sysImg/gettypeList',
        method: 'GET',
        params: data
    });
}

/**
 *  分页获取城市站数据
 * */
export function getCityManagePage(data) {
    return fetch({
        url: '/cityManage/getCityManagePage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取城市站数据
 * */
export function getCityManageList(data) {
    return fetch({
        url: '/cityManage/getCityManageList',
        method: 'get',
        params: data
    });
}

/**
 * 获取城市列表中省份编码
 * @param {*} data
 */
export function getRegionProvince(data) {
    return fetch({
        url: '/cityManage/getRegionProvince',
        method: 'get',
        params: data
    });
}


/**
 *  新增或编辑城市站
 * */
export function modifyCityManage(data) {
    return fetch({
        url: '/cityManage/modifyCityManage',
        method: 'POST',
        data
    });
}

/**
 * 获取所属城市
 * @param {*} data
 */
export function getRegionPidById(data) {
    return fetch({
        url: '/region/getRegionPidById',
        method: 'POST',
        data
    });
}

/**
 *  删除城市站
 * */
export function deleteCityManageById(data) {
    return fetch({
        url: '/cityManage/deleteCityManageById',
        method: 'get',
        params: data
    });
}

/**
 *  根据Id获取城市站详细信息
 * */
export function getCityManageDetailById(data) {
    return fetch({
        url: '/cityManage/getCityManageDetailById',
        method: 'get',
        params: data
    });
}

/**
 *  分页获取城市站管理员数据
 * */
export function getCityManagePersonPage(data) {
    return fetch({
        url: '/cityManagePerson/getCityManagePersonPage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取城市站管理员数据
 * */
export function getCityManagePersonList(data) {
    return fetch({
        url: '/cityManagePerson/getCityManagePersonList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑城市站管理员
 * */
export function modifyCityManagePerson(data) {
    return fetch({
        url: '/cityManagePerson/modifyCityManagePerson',
        method: 'POST',
        data
    });
}

/**
 *  删除城市站管理员
 * */
export function deleteCityManagePersonById(data) {
    return fetch({
        url: '/cityManagePerson/deleteCityManagePersonById',
        method: 'get',
        params: data
    });
}

/**
 *  根据Id获取城市站管理员详细信息
 * */
export function getCityManagePersonDetailById(data) {
    return fetch({
        url: '/cityManagePerson/getCityManagePersonDetailById',
        method: 'get',
        params: data
    });
}

/**
 *  分页获取会员单位数据
 * */
export function getMemberTeamPage(data) {
    return fetch({
        url: '/memberTeam/getMemberTeamPage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取会员单位数据
 * */
export function getMemberTeamList(data) {
    return fetch({
        url: '/memberTeam/getMemberTeamList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑会员单位
 * */
export function modifyMemberTeam(data) {
    return fetch({
        url: '/memberTeam/modifyMemberTeam',
        method: 'POST',
        data
    });
}

/**
 *  删除会员单位
 * */
export function deleteMemberTeamById(data) {
    return fetch({
        url: '/memberTeam/deleteMemberTeamById',
        method: 'get',
        params: data
    });
}

/**
 *  根据Id获取会员单位详细信息
 * */
export function getMemberTeamDetailById(data) {
    return fetch({
        url: '/memberTeam/getMemberTeamDetailById',
        method: 'get',
        params: data
    });
}


/**
 *  分页获取${metaName}数据
 * */
export function getRegionPage(data) {
    return fetch({
        url: '/region/getRegionPage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取${metaName}数据
 * */
export function getRegionList(data) {
    return fetch({
        url: '/region/getRegionList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑${metaName}
 * */
export function modifyRegion(data) {
    return fetch({
        url: '/region/modifyRegion',
        method: 'POST',
        data
    });
}

/**
 *  删除${metaName}
 * */
export function deleteRegionById(data) {
    return fetch({
        url: '/region/deleteRegionById',
        method: 'get',
        params: data
    });
}

/**
 *  根据Id获取${metaName}详细信息
 * */
export function getRegionDetailById(data) {
    return fetch({
        url: '/region/getRegionDetailById',
        method: 'get',
        params: data
    });
}

/**
 * 修改密码
 */
export function updatePassword(data){
    return fetch({
        url: '/admin/updatePassword',
        method: 'post',
        params: data
    });
}

/**
 * 重置密码
 */
export function reloadPassword(data){
    return fetch({
        url: '/admin/reloadPassword',
        method: 'post',
        params: data
    });
}

/**
 *  分页获取常见使用Q&A数据
 * */
export function getQuestionAndAnswerPage(data) {
    return fetch({
        url: '/questionAndAnswer/getQuestionAndAnswerPage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取常见使用Q&A数据
 * */
export function getQuestionAndAnswerList(data) {
    return fetch({
        url: '/questionAndAnswer/getQuestionAndAnswerList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑常见使用Q&A
 * */
export function modifyQuestionAndAnswer(data) {
    return fetch({
        url: '/questionAndAnswer/modifyQuestionAndAnswer',
        method: 'POST',
        data
    });
}

/**
 *  删除常见使用Q&A
 * */
export function deleteQuestionAndAnswerById(data) {
    return fetch({
        url: '/questionAndAnswer/deleteQuestionAndAnswerById',
        method: 'get',
        params: data
    });
}

/**
 *  根据Id获取常见使用Q&A详细信息
 * */
export function getQuestionAndAnswerDetailById(data) {
    return fetch({
        url: '/questionAndAnswer/getQuestionAndAnswerDetailById',
        method: 'get',
        params: data
    });
}

/**
 *  分页获取用户反馈中心数据
 * */
export function getTeamFeedbackPage(data) {
    return fetch({
        url: '/teamFeedback/getTeamFeedbackPage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取用户反馈中心数据
 * */
export function getTeamFeedbackList(data) {
    return fetch({
        url: '/teamFeedback/getTeamFeedbackList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑用户反馈中心
 * */
export function modifyTeamFeedback(data) {
    return fetch({
        url: '/teamFeedback/modifyTeamFeedback',
        method: 'POST',
        data
    });
}

/**
 *  删除用户反馈中心
 * */
export function deleteTeamFeedbackById(data) {
    return fetch({
        url: '/teamFeedback/deleteTeamFeedbackById',
        method: 'get',
        params: data
    });
}

/**
 *  根据Id获取用户反馈中心详细信息
 * */
export function getTeamFeedbackDetailById(data) {
    return fetch({
        url: '/teamFeedback/getTeamFeedbackDetailById',
        method: 'get',
        params: data
    });
}

/**
 *  分页获取团队活动留言数据
 * */
export function getTeamActivityMessagePage(data) {
    return fetch({
        url: '/teamActivityMessage/getTeamActivityMessagePage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取团队活动留言数据
 * */
export function getTeamActivityMessageList(data) {
    return fetch({
        url: '/teamActivityMessage/getTeamActivityMessageList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑团队活动留言
 * */
export function modifyTeamActivityMessage(data) {
    return fetch({
        url: '/teamActivityMessage/modifyTeamActivityMessage',
        method: 'POST',
        data
    });
}

/**
 *  删除团队活动留言
 * */
export function deleteTeamActivityMessageById(data) {
    return fetch({
        url: '/teamActivityMessage/deleteTeamActivityMessageById',
        method: 'get',
        params: data
    });
}

/**
 *  根据Id获取团队活动留言详细信息
 * */
export function getTeamActivityMessageDetailById(data) {
    return fetch({
        url: '/teamActivityMessage/getTeamActivityMessageDetailById',
        method: 'get',
        params: data
    });
}

/**
 *  分页获取团队留言数据
 * */
export function getTeamMessagePage(data) {
    return fetch({
        url: '/teamMessage/getTeamMessagePage',
        method: 'get',
        params: data
    });
}

/**
 *  列表获取团队留言数据
 * */
export function getTeamMessageList(data) {
    return fetch({
        url: '/teamMessage/getTeamMessageList',
        method: 'get',
        params: data
    });
}

/**
 *  新增或编辑团队留言
 * */
export function modifyTeamMessage(data) {
    return fetch({
        url: '/teamMessage/modifyTeamMessage',
        method: 'POST',
        data
    });
}

/**
 *  删除团队留言
 * */
export function deleteTeamMessageById(data) {
    return fetch({
        url: '/teamMessage/deleteTeamMessageById',
        method: 'get',
        params: data
    });
}

/**
 *  根据Id获取团队留言详细信息
 * */
export function getTeamMessageDetailById(data) {
    return fetch({
        url: '/teamMessage/getTeamMessageDetailById',
        method: 'get',
        params: data
    });
}

/**
 * 导入志愿者
 */
export function importZhiyuanzhe(data) {
    return fetch({
        url: '/zhiyuanzhe/fileLoad',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data,
        responseType: "blob"
    });
}/**图片上传 */
export function uploadImg(data){
    return fetch({
        baseURL: uploadImgPath,
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function generateQrCode(data) {
    return fetch({
        url: '/teamActivity/generateQrCode',
        method: 'get',
        params: data,
        responseType: "blob"
    });
}



// WEBPACK FOOTER //
// ./src/api/getData.js